export default "__VITE_ASSET__B$LYDwU8__"